import { _ } from "../../../core/polyglot/polyglot.js";
import { formatAsRelativeDate } from "../../../core/helpers/date-formatting-util.js";
import abstractPeriodReportArchiveSectionWidget from "./abstractPeriodReportArchiveSectionWidget.js";
import GridColumnSpecification from "../../../core/widgets/list/GridColumnSpecification.js";
import ReportStatusIcon from "./ReportStatusIcon.js";
import TableStrategy from "../../../core/widgets/list/ListSourceWidget/strategies/TableStrategy.js";

/**
 * `periodReportArchiveListSectionWidget` is a period report section displaying a list of items as widgets
 *
 * @param {*} spec - Parameter object
 * @param {*} my - protected fields holder
 * @return {{}}
 */
function periodReportArchiveListSectionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractPeriodReportArchiveSectionWidget(spec, my);

	my.checkBoxRenderer = function (report) {
		let checkbox;
		return function (html) {
			const td = html.td(
				{
					klass: "selection-input",
				},
				(html) => {
					checkbox = html.input({
						type: "checkbox",
					});
				},
			);

			if (my.selectionPredicate(report)) {
				checkbox.attr({ checked: true });
			}

			my.addClickEvent(td, report);
		};
	};

	my.nameRenderer = function (report) {
		const statusIcon = spec.canSeePeriodReportViewers
			? new ReportStatusIcon({
					reportSummary: report,
				})
			: "";

		return function (html) {
			const div = html.div(
				{ klass: "name-container" },
				html.a(
					{
						href: my.linkTo(
							report.isDraft()
								? "edit-period-report"
								: "period-report",
							{
								id: report.getId(),
							},
						),
					},
					report.getTitle(),
					statusIcon,
				),
			);

			my.addClickEvent(div, report);
		};
	};

	my.authorRenderer = function (report) {
		return function (html) {
			const div = html.div(report.getAuthor() || _("N/A"));

			my.addClickEvent(div, report);
		};
	};

	my.lastUpdateTimeRenderer = function (report) {
		return function (html) {
			let div;
			const lastUpdateDate = report.getLastUpdateDate();
			if (lastUpdateDate) {
				div = html.div(formatAsRelativeDate(lastUpdateDate));
			} else {
				div = html.div("-");
			}
			my.addClickEvent(div, report);
		};
	};

	my.getGridClass = function () {
		return TableStrategy;
	};

	my.getExtraOptions = function () {
		return {
			bordered: true,
			striped: true,
			highlightOnHover: true,
			cssClass: "period-report-archive-table",
			columnSpecifications: [
				new GridColumnSpecification({
					name: "",
					headerCssClass: "selection-header",
					cssClass: "selection-input",
					renderer: my.checkBoxRenderer,
				}),
				new GridColumnSpecification({
					name: _("Name"),
					cssClass: "report-name",
					sortCriterion: "title",
					renderer: my.nameRenderer,
				}),
				new GridColumnSpecification({
					name: _("Author"),
					cssClass: "author",
					sortCriterion: "author",
					renderer: my.authorRenderer,
				}),
				new GridColumnSpecification({
					name: _("Creation date"),
					sortCriterion: "lastUpdateDate",
					type: "number",
					cssClass: "report-creation-date",
					renderer: my.lastUpdateTimeRenderer,
				}),
			],
		};
	};

	my.addClickEvent = function (tag, report) {
		tag.click(() => {
			if (my.selectionPredicate(report)) {
				that.onResetSelection.trigger();
			} else {
				that.onSelect.trigger(report);
			}
		});

		return tag;
	};

	return that;
}

export default periodReportArchiveListSectionWidget;
